// external
import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { NavLink } from "react-router-dom";
import { withRouter } from "react-router-dom";

// internal
import { customize } from "utils/hoc/Customize";
import history from "components/common/navigation/AppHistory";

class CustomLinkUI extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPath: history.location.pathname,
      hovered: false,
    };
  }

  componentDidMount() {
    if (this.props.isRouterLink) {
      this.unlistenHistory = history.listen((location) => {
        if (location.pathname != this.state.currentPath) {
          this.setState({
            currentPath: location.pathname,
          });
        }
      });
    }
  }

  componentWillUnmount() {
    if (this.unlistenHistory) {
      this.unlistenHistory();
    }
  }

  getLinkStyles() {
    const { isTitle, isRouterLink, to, namespace, getStyles } = this.props;
    const { currentPath, hovered } = this.state;

    let section = "text";
    if (isTitle) section = "title";

    if (hovered || (isRouterLink && currentPath === to)) {
      section = "text_hover";
      if (isTitle) section = "title_hover";
    }

    return getStyles(`${namespace}:${section}`);
  }

  onLinkOver = (e) => {
    let hovered = false;
    if (e) {
      if (e.type === "mouseenter") {
        hovered = true;
      }
      if (e.type === "mouseleave") {
        hovered = false;
      }
    }

    this.setState({ hovered });
  };

  getProps = () => {
    const notAllowedProps = [
      "getStyles",
      "isRouterLink",
      "isTitle",
      "history",
      "location",
      "match",
      "namespace",
      "staticContext",
      "to",
      "locationState",
    ];

    return Object.keys(this.props)
      .filter((key) => !notAllowedProps.includes(key))
      .reduce((obj, key) => {
        obj[key] = this.props[key];
        return obj;
      }, {});
  };

  getRouterLink = () => {
    const props = this.getProps();
    const styles = this.getLinkStyles();
    const { to, locationState } = this.props;

    return (
      <NavLink
        style={styles}
        onMouseEnter={this.onLinkOver}
        onMouseLeave={this.onLinkOver}
        to={{
          pathname: to,
          state: locationState,
        }}
        {...props}
      >
        {this.state.c}
        {this.props.children}
      </NavLink>
    );
  };

  getLink = () => {
    const props = this.getProps();
    const styles = this.getLinkStyles();

    return (
      <a
        style={styles}
        onMouseEnter={this.onLinkOver}
        onMouseLeave={this.onLinkOver}
        href={this.props.to}
        {...props}
      >
        {this.props.children}
      </a>
    );
  };

  render() {
    if (this.props.isRouterLink) {
      return this.getRouterLink();
    }
    return this.getLink();
  }
}

CustomLinkUI.propTypes = {
  children: PropTypes.node,
  getStyles: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  isRouterLink: PropTypes.bool,
  isTitle: PropTypes.bool,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  namespace: PropTypes.string.isRequired,
  to: PropTypes.string,
  locationState: PropTypes.object,
};

CustomLinkUI.defaultProps = {
  isTitle: false,
  to: "",
  locationState: null,
};

export default withRouter(customize()(CustomLinkUI));
